import { type RawScanEvent } from '../types/scanEvent.type';
import {
  type ScanEventQueue,
  type ScanEventQueueListener,
  type ScanEventQueueOptions,
} from '../types/scanEventQueue.type';
import { createScanEventQueueConsumerAlreadySubscribedError } from './scanEventQueueError.util';

const DEFAULT_CAPACITY = 30;

export const createScanEventQueue = ({
  capacity = DEFAULT_CAPACITY,
}: ScanEventQueueOptions = {}): ScanEventQueue => {
  const events: RawScanEvent[] = [];
  let listener: ScanEventQueueListener | undefined;

  const notify = () => listener?.();

  return {
    dequeue: () => events.shift(),
    enqueue: (event) => {
      if (events.some(({ barcodeValue }) => barcodeValue === event.barcodeValue))
        return { status: 'rejected_duplicate' };

      if (events.length >= capacity) return { status: 'rejected_overflow' };

      events.push(event);
      notify();

      return { status: 'accepted' };
    },
    peek: (barcodeValue) =>
      barcodeValue === undefined
        ? events[0]
        : events.find((event) => event.barcodeValue === barcodeValue),
    size: () => events.length,
    subscribe: (nextListener) => {
      if (listener) throw createScanEventQueueConsumerAlreadySubscribedError();

      listener = nextListener;

      if (events.length > 0) {
        try {
          notify();
        } catch (error) {
          listener = undefined;
          throw error;
        }
      }

      let active = true;

      return () => {
        if (active && listener === nextListener) listener = undefined;
        active = false;
      };
    },
  };
};
